import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const DARK = 'var(--lm-bg-1a1f2b)';
const BORDER = 'rgba(var(--th-6c4f9b-rgb), 0.4)';

const headingStyle = { color: 'var(--lm-tx-f5f5f5)', marginTop: 24, marginBottom: 10 };
const markdownComponents = {
    h1: ({ node, ...props }) => <h4 style={{ ...headingStyle, marginTop: 0 }} {...props} />,
    h2: ({ node, ...props }) => <h5 style={headingStyle} {...props} />,
    h3: ({ node, ...props }) => <h6 style={{ ...headingStyle, fontSize: '0.95rem' }} {...props} />,
    a: ({ node, ...props }) => <a style={{ color: 'var(--lm-tx-th-c9a0f0)' }} target="_blank" rel="noopener noreferrer" {...props} />,
    code: ({ node, ...props }) => (
        <code style={{ color: 'var(--lm-tx-th-c9a0f0)', backgroundColor: 'rgba(var(--th-6c4f9b-rgb), 0.15)', padding: '1px 5px', borderRadius: 3, fontSize: '0.85em' }} {...props} />
    ),
    table: ({ node, ...props }) => (
        <div style={{ overflowX: 'auto', margin: '12px 0' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.82rem' }} {...props} />
        </div>
    ),
    th: ({ node, ...props }) => <th style={{ textAlign: 'left', padding: '6px 10px', borderBottom: `1px solid ${BORDER}`, color: 'var(--lm-tx-f5f5f5)' }} {...props} />,
    td: ({ node, ...props }) => <td style={{ padding: '6px 10px', borderBottom: '1px solid rgba(var(--lm-veil-rgb),0.08)', verticalAlign: 'top' }} {...props} />,
    hr: ({ node, ...props }) => <hr style={{ borderColor: BORDER, margin: '28px 0' }} {...props} />,
};

// A full-page legal document (Privacy Policy, Terms of Use). The text is fetched at runtime
// from public/content rather than bundled, so it can be edited and redeployed without a code
// change. These are plain routes, not gates: they have to be reachable by logged-out visitors
// (and linked from Stripe checkout and the signup form), so each is registered in both the
// authenticated and unauthenticated Routes blocks in App.js.
export default function LegalDocumentPage({ url, title, Icon }) {
    const [text, setText] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        fetch(url)
            .then(res => res.ok ? res.text() : Promise.reject(res))
            .then(setText)
            .catch(() => setText(`Unable to load the ${title}. Please refresh and try again.`));
    }, [url, title]);

    return (
        <div style={{ backgroundColor: DARK, minHeight: '100vh', width: '100%', overflowY: 'auto', padding: '32px 16px' }}>
            <div style={{ maxWidth: 860, margin: '0 auto' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 20 }}>
                    <Icon style={{ height: 26, width: 26, color: 'var(--lm-tx-th-c9a0f0)' }} />
                    <h3 style={{ color: 'var(--lm-tx-f5f5f5)', fontSize: '1.1rem', margin: 0, flexGrow: 1 }}>{title}</h3>
                    <Button onClick={() => navigate(-1)} sx={{ color: 'var(--lm-tx-f5f5f5)', textTransform: 'none' }}>
                        Back
                    </Button>
                </div>
                <div style={{ color: 'var(--lm-tx-th-e4e0ec)', fontSize: '0.87rem', lineHeight: 1.7 }}>
                    <ReactMarkdown components={markdownComponents}>{text}</ReactMarkdown>
                </div>
            </div>
        </div>
    );
}
